import React from "react";
import TwoFa from "../elements/twoFa/TwoFa";

import { StyledForm, StyledFormContent } from "../styles/styledForm";
import { StyledLoginBackButton, StyledLoginFormHead, StyleFormTitle } from "./styledLogin";


const LoginConfirmForm = ({handleSubmit, handleGoBack, error, loading, t}) => {
  return (
    <StyledForm as="div" className="login-form">
      <StyledLoginFormHead>
        <StyleFormTitle as="h2">
          {t("twofaTitle")}
        </StyleFormTitle>
      </StyledLoginFormHead>
      <StyledFormContent className="login-form__content">
        <TwoFa
          handleSubmit={handleSubmit}
          error={error}
          loading={loading}
          autoSubmit
        >
          <StyledLoginBackButton
            type="button"
            disabled={loading}
            onClick={handleGoBack}
          >
            {t("back")}
          </StyledLoginBackButton>
        </TwoFa>
      </StyledFormContent>
    </StyledForm>
  );
};

export default LoginConfirmForm;